import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getQueryParam } from '../../lib/utils';
import { BackButton } from '../shared/buttons/BackButton';
import { ErrorScreenContent } from './ErrorScreenContent';

export const ErrorScreenDebug: React.FC = () => {
  const { t } = useTranslation('settings');
  const location = useLocation();
  const errorCode = getQueryParam(location.search, 'code');

  return (
    <>
      <div
        className={css`
          position: absolute;
          top: 0;
          display: flex;
          width: 100%;
        `}
      >
        <BackButton ariaLabel={t('aria_back_to_settings')} />
      </div>
      <ErrorScreenContent errorCode={errorCode} />
    </>
  );
};
